var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"login-container"},[_c('v-container',[_c('v-img',{staticClass:"my-4",attrs:{"src":require('@/assets/logo.png'),"contain":"","height":"50"}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }